import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useWaitlist } from '../context/WaitlistContext';
import '../styles/Navigation.css';

const Navigation = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const timeoutRef = useRef(null);
  const { openModal } = useWaitlist();

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsDropdownOpen(false);
    }, 100);
  };

  return (
    <>
      <div className={`nav-background ${isDropdownOpen ? 'expanded' : ''}`}>
        <nav>
        <div className="container">
          <div className="nav-top-row">
            <div className="nav-group-left">
            <Link to="/" className="logo-wrapper">
            <svg width="96" height="18" viewBox="0 0 96 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M87.6934 9.91327V15.6936H85.3689V5.81226H87.6492V7.50039H87.7641C87.9881 6.94652 88.3386 6.50755 88.8159 6.18347C89.2991 5.8535 89.9119 5.68852 90.6543 5.68852C91.3378 5.68852 91.9329 5.83288 92.4396 6.1216C92.9464 6.41032 93.3382 6.83457 93.6152 7.39433C93.898 7.9482 94.0394 8.61992 94.0394 9.40948V15.6936H91.7149V9.77186C91.7149 9.11192 91.544 8.59635 91.2023 8.22514C90.8605 7.84803 90.3891 7.65948 89.7881 7.65948C89.3816 7.65948 89.0192 7.74787 88.701 7.92463C88.3887 8.1014 88.1412 8.35771 87.9586 8.69357C87.7818 9.02354 87.6934 9.4301 87.6934 9.91327Z" fill="black"/>
<path d="M79.35 15.888C78.3837 15.888 77.547 15.6759 76.8399 15.2517C76.1328 14.8274 75.5848 14.2323 75.196 13.4663C74.813 12.7003 74.6215 11.8106 74.6215 10.7971C74.6215 9.77775 74.813 8.88507 75.196 8.11908C75.5848 7.34719 76.1328 6.74913 76.8399 6.32489C77.547 5.90064 78.3837 5.68852 79.35 5.68852C80.3163 5.68852 81.153 5.90064 81.8601 6.32489C82.5672 6.74913 83.1151 7.34719 83.504 8.11908C83.8929 8.88507 84.0874 9.77775 84.0874 10.7971C84.0874 11.8106 83.8929 12.7003 83.504 13.4663C83.1151 14.2323 82.5672 14.8274 81.8601 15.2517C81.153 15.6759 80.3163 15.888 79.35 15.888ZM79.35 14.0143C79.8862 14.0143 80.3281 13.8729 80.6758 13.59C81.0234 13.3013 81.2827 12.9124 81.4535 12.4234C81.6303 11.9343 81.7187 11.3922 81.7187 10.7971C81.7187 10.1902 81.6303 9.64223 81.4535 9.15317C81.2827 8.66411 81.0234 8.27817 80.6758 7.99534C80.3281 7.70662 79.8862 7.56226 79.35 7.56226C78.8256 7.56226 78.3866 7.70662 78.0331 7.99534C77.6795 8.27817 77.4144 8.66411 77.2376 9.15317C77.0667 9.64223 76.9813 10.1902 76.9813 10.7971C76.9813 11.3922 77.0667 11.9343 77.2376 12.4234C77.4144 12.9124 77.6795 13.3013 78.0331 13.59C78.3866 13.8729 78.8256 14.0143 79.35 14.0143Z" fill="black"/>
<path d="M70.9977 15.6937V5.81241H73.3222V15.6937H70.9977ZM72.1644 4.42478C71.7931 4.42478 71.475 4.30105 71.2098 4.05357C70.9447 3.8061 70.8121 3.50854 70.8121 3.1609C70.8121 2.80736 70.9447 2.50686 71.2098 2.25938C71.475 2.01191 71.7931 1.88817 72.1644 1.88817C72.5297 1.88817 72.8449 2.01191 73.1101 2.25938C73.3752 2.50686 73.5078 2.80441 73.5078 3.15206C73.5078 3.50559 73.3752 3.8061 73.1101 4.05357C72.8449 4.30105 72.5297 4.42478 72.1644 4.42478Z" fill="black"/>
<path d="M72.8272 5.8124V7.61543H64.0507V5.8124H72.8272ZM65.4383 3.4614H67.7628V12.724C67.7628 13.1129 67.8483 13.4016 68.0191 13.5902C68.19 13.7728 68.4611 13.8642 68.8323 13.8642C68.9324 13.8642 69.0444 13.8553 69.1681 13.8377C69.2919 13.82 69.4038 13.7994 69.504 13.7758V15.7013C69.3868 15.7268 69.2689 15.7479 69.1505 15.7644C68.8971 15.8057 68.6437 15.8263 68.3903 15.8263C67.4712 15.8263 66.7494 15.5847 66.2249 15.1015C65.7005 14.6125 65.4383 13.9467 65.4383 13.1041V3.4614Z" fill="black"/>
<path d="M57.2982 12.6001L57.2893 9.78065H57.6694L61.2136 5.81222H63.9358L59.5696 10.6822H59.0835L57.2982 12.6001ZM55.177 15.6935V2.52434H57.5015V15.6935H55.177ZM61.3727 15.6935L58.1555 11.2036L59.7287 9.55969L64.1568 15.6935H61.3727Z" fill="black"/>
<path d="M51.129 15.6937V5.81241H53.4535V15.6937H51.129ZM52.2957 4.42478C51.9245 4.42478 51.6063 4.30105 51.3412 4.05357C51.076 3.8061 50.9434 3.50854 50.9434 3.1609C50.9434 2.80736 51.076 2.50686 51.3412 2.25938C51.6063 2.01191 51.9245 1.88817 52.2957 1.88817C52.661 1.88817 52.9763 2.01191 53.2414 2.25938C53.5066 2.50686 53.6391 2.80441 53.6391 3.15206C53.6391 3.50559 53.5066 3.8061 53.2414 4.05357C52.9763 4.30105 52.661 4.42478 52.2957 4.42478Z" fill="black"/>
<path d="M41.2919 15.6935V2.52434H49.7414V4.52181H43.6782V8.47257H49.1492V10.4435H43.6782V15.6935H41.2919Z" fill="black"/>
<circle cx="8.5" cy="9" r="8.5" fill="black"/>
<path d="M17 17.5C18.1162 17.5 19.2215 17.2801 20.2528 16.853C21.2841 16.4258 22.2211 15.7997 23.0104 15.0104C23.7997 14.2211 24.4258 13.2841 24.853 12.2528C25.2801 11.2215 25.5 10.1162 25.5 9C25.5 7.88376 25.2801 6.77846 24.853 5.74719C24.4258 4.71592 23.7997 3.77889 23.0104 2.98959C22.2211 2.20029 21.2841 1.57419 20.2528 1.14702C19.2215 0.719859 18.1162 0.5 17 0.5L17 9L17 17.5Z" fill="black"/>
<path d="M25.5 17.5C26.6162 17.5 27.7215 17.2801 28.7528 16.853C29.7841 16.4258 30.7211 15.7997 31.5104 15.0104C32.2997 14.2211 32.9258 13.2841 33.353 12.2528C33.7801 11.2215 34 10.1162 34 9C34 7.88376 33.7801 6.77846 33.353 5.74719C32.9258 4.71592 32.2997 3.77889 31.5104 2.98959C30.7211 2.20029 29.7841 1.57419 28.7528 1.14702C27.7215 0.719859 26.6162 0.5 25.5 0.5L25.5 9L25.5 17.5Z" fill="black"/>
</svg>


            </Link>
            <ul className="nav-links">
            <li 
              className="dropdown"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <span>Product</span>
            </li>
            <li><Link to="/mobile">Mobile</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
          </div>
          <div className="nav-group-right">
              <a href="https://app.fiktion.io/login" target="_blank" rel="noopener noreferrer"><button className="btn btn-small btn-ghost">Log in</button></a>
              <a href="https://app.fiktion.io/signup" target="_blank" rel="noopener noreferrer"><button className="btn btn-small btn-primary">Sign up</button></a>
              <button 
                className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                aria-label="Toggle menu"
              >
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
          <div 
            className="dropdown-wrapper"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="dropdown-content">
              <Link to="/product/ideate" className="dropdown-item">
                <h4>Ideate</h4>
                <p>Jot down ideas, chirps of dialogue and sudden sparks of genius.</p>
              </Link>
              <Link to="/product/outline" className="dropdown-item">
                <h4>Outline</h4>
                <p>Outline your story using Fiktion's intuitive beat sheet and timeline.</p>
              </Link>
                <Link to="/product/write" className="dropdown-item">
                  <h4>Write</h4>
                  <p>Fiktion brings you an intuitive and professional writing experience.</p>
                </Link>
              </div>
            </div>
            <div 
              className="nav-bottom"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Link to="/product/features">View all features at a glance</Link>
            </div>
          </div>
        </nav>
      </div>
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <ul className="mobile-menu-links">
            <li className="mobile-menu-item">
              <span className="mobile-menu-label">Product</span>
              <ul className="mobile-submenu">
                <li><Link to="/product/ideate" onClick={() => setIsMobileMenuOpen(false)}>Ideate</Link></li>
                <li><Link to="/product/outline" onClick={() => setIsMobileMenuOpen(false)}>Outline</Link></li>
                <li><Link to="/product/write" onClick={() => setIsMobileMenuOpen(false)}>Write</Link></li>
                <li><Link to="/product/features" onClick={() => setIsMobileMenuOpen(false)}>All features</Link></li>
              </ul>
            </li>

            <li className="mobile-menu-item">
              <span className="mobile-menu-label">Fiktion</span>
              <ul className="mobile-submenu small-submenu">
                <li><Link to="/mobile" onClick={() => setIsMobileMenuOpen(false)}>Mobile</Link></li>
                <li><Link to="/about" onClick={() => setIsMobileMenuOpen(false)}>About</Link></li>
                <li><Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</Link></li>
                <li><Link to="/download" onClick={() => setIsMobileMenuOpen(false)}>Download</Link></li>
                <li><Link to="/brand" onClick={() => setIsMobileMenuOpen(false)}>Brand</Link></li>
                <li><Link to="/pricing" onClick={() => setIsMobileMenuOpen(false)}>Pricing</Link></li>
              </ul>
            </li>
            <li className="mobile-menu-item">
              <span className="mobile-menu-label">Resources</span>
              <ul className="mobile-submenu small-submenu">
                <li><Link to="/qa" onClick={() => setIsMobileMenuOpen(false)}>Q&A</Link></li>
                <li><Link to="/buy-scripts" onClick={() => setIsMobileMenuOpen(false)}>Buy scripts</Link></li>
                <li><Link to="/switch" onClick={() => setIsMobileMenuOpen(false)}>Switch</Link></li>
              </ul>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default Navigation;


